/**
 * What must be re-read once a session is established. The account and
 * organization atoms are warm and shared across the app, and components that
 * mount before sign-in (the analytics bridge, for one) already asked for
 * them and cached the signed-out answer — a 401 — which the workspace would
 * otherwise show as "couldn't load your organizations" until a manual retry.
 */
import { refreshAccountProfile } from "./accountProfile";
import { refreshOrgs } from "./orgs";

export function refreshSessionScopedState(): void {
  refreshOrgs();
  refreshAccountProfile();
}
